export default __webpack_public_path__ + "static/media/bti-dropdown.d411062b.webp";